import { createPropertySelectors, createSelector } from '@ngxs/store';

import { HostModeState, HostModeStateModel } from './host-mode.state';
import { TablesStateSelectors } from 'src/app/store/tables/tables.selectors';
import { TableConstant } from 'src/app/constants';
import { SeatedDiner } from 'src/app/models';

export class HostModeSelectors {
  static slices = createPropertySelectors<HostModeStateModel>(HostModeState);

  static getDiners = createSelector(
    [HostModeSelectors.slices.diners],
    (diners) => diners
  );

  static getPendingSeatAssignments = createSelector(
    [HostModeSelectors.slices.pendingSeatAssignments],
    (pendingSeatAssignments) => pendingSeatAssignments
  );

  static selectedTableId = createSelector(
    [HostModeSelectors.slices.selectedTable],
    (selectedTableId) => selectedTableId
  );

  static readonly isTableSelected = createSelector(
    [HostModeSelectors.selectedTableId],
    (selectedTableId) => !!selectedTableId
  );

  static getSelectedTablePendingAssignments = createSelector(
    [
      TablesStateSelectors.getSelectedTableId,
      HostModeSelectors.getPendingSeatAssignments,
      HostModeSelectors.selectedTableId
    ],
    (tableId, pendingSeatAssignments, hostModeTableId) =>
      pendingSeatAssignments.filter(
        (seat) => seat.table_id === (tableId || hostModeTableId)
      )
  );

  static getDinersByTable = createSelector(
    [
      HostModeSelectors.getDiners,
      HostModeSelectors.getSelectedTablePendingAssignments
    ],
    (addedDiners, pendingSeatAssignments) => {
      const diners = [...pendingSeatAssignments, ...addedDiners];
      return diners;
    }
  );

  static getSelectedTable = createSelector(
    [
      HostModeSelectors.selectedTableId,
      TablesStateSelectors.getFormattedTables
    ],
    (tableId, tables) => (tables || []).find((t) => t.id === tableId)
  );

  static getSeatedDinersByTable = createSelector(
    [HostModeSelectors.getSelectedTable],
    (selectedTable) =>
      selectedTable
        ? selectedTable.seats
            .filter((seat) => seat.ticket_created_at)
            .map(
              ({
                diner_id,
                last_name,
                first_name,
                floorplan_status,
                ticket_created_at,
                diner_name
              }) => {
                const seatedDiner: SeatedDiner = {
                  diner_id,
                  last_name,
                  first_name,
                  name:
                    !first_name && !last_name
                      ? diner_name ?? 'Guest Diner'
                      : [first_name, last_name].join(' '),
                  table_name: selectedTable.name,
                  table_id: selectedTable.id,
                  floorplan_status,
                  created_at: new Date(ticket_created_at)
                };
                return seatedDiner;
              }
            )
        : []
  );

  static getSelectedTableAvailableSeats = createSelector(
    [HostModeSelectors.getSelectedTable],
    (table) =>
      !table
        ? []
        : table.seats.filter(
            (seat) =>
              !!seat.align &&
              (!seat.floorplan_status ||
                !seat.ticket_status ||
                TableConstant.EMPTY_TICKET_STATUS.includes(seat.ticket_status))
          )
  );
}
